import { Injectable } from '@angular/core';
import { BreakpointObserver } from "@angular/cdk/layout";
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreakpointWatcherService {

  /** Create a map to display breakpoint names for demonstration purposes */
  private display_device_map = new Map([
    ['(min-width: 1200px)', 'desktop'],
    ['(min-width: 768px) and (max-width: 1200px)', 'tablet'],
    ['(max-width: 768px)', 'mobile'],
  ]);

  constructor(private _breakpointObserver: BreakpointObserver) { };

  public watchBreakPoints(){
    return this._breakpointObserver
      .observe([
        '(min-width: 1200px)',
        '(min-width: 768px) and (max-width: 1200px)',
        '(max-width: 768px)'
      ])
      .pipe(
        map((result) => {
          let screen;
          for (const [query, breakpoint] of Object.entries(result.breakpoints)) {
            if (breakpoint) {
              screen = this.display_device_map.get(query);
              break;
            }
          }
          return screen;
        })
      )
  }
}
